module.exports = __webpack_public_path__ + "static/media/notification.22c28e5e.svg";